import { grapeVarieties } from '../domain/filters';
import { canonicalCepage } from '../domain/grapes';
import { t } from '../i18n';
import { MultiSelectField } from './MultiSelectField';

/**
 * The Cépage (owner request, 2026-10-04): the varieties are ticked in a list with a search box,
 * several for a blend, rather than typed; a variety the list lacks can be added from the search.
 * The value stays the stored text, its varieties A to Z joined by commas (domain/grapes.ts).
 * Without `label`, the field edited in place names it (`buttonId`). With `listed` (owner,
 * 2026-10-08: the wine's region's grapes, domain/region-grapes.ts), only those are listed until
 * something is typed; the search covers every variety.
 */
export function GrapePicker({
  label,
  buttonId,
  value,
  choices,
  onChange,
  listed,
}: {
  label?: string;
  buttonId?: string;
  value: string;
  /** The cellar's choices (domain/grapes.ts `grapeChoices`). */
  choices: readonly string[];
  onChange: (cepage: string) => void;
  listed?: readonly string[] | undefined;
}) {
  const selected = grapeVarieties(canonicalCepage(value, choices));
  // A variety just added, or read from a label, is a choice too until the wine is saved.
  const all = [...new Set([...choices, ...selected])].sort((a, b) =>
    a.localeCompare(b, 'fr', { sensitivity: 'base' }),
  );
  const set = (varieties: string[]) => onChange(canonicalCepage(varieties.join(', '), all));
  return (
    <MultiSelectField
      {...(label !== undefined ? { label } : {})}
      {...(buttonId !== undefined ? { buttonId } : {})}
      choices={all}
      selected={selected}
      onChange={set}
      emptyLabel={t('wine.chooseCepage')}
      searchable
      onAdd={(variety) => set([...selected, variety])}
      {...(listed !== undefined ? { listed } : {})}
    />
  );
}
